import { useStore } from '../../../store';

const store = useStore();

export const getUrl = () => {
    let url = `/rest/v1/news?&page[size]=8`;

    if (store.state.press.calendar[0] && !store.state.press.calendar[1]) {
        store.state.press.calendar[1] = store.state.press.calendar[0];
    }

    // Свитчер
    url = store.state.press.switcher === 'news' ? url : `${url}&where[section]=media-about-us`;

    // Поиск
    url = !store.state.press.searchActive ? url : `${url}&where[search]=${store.state.press.searchValue}`;

    // Календарь
    url = !store.state.press.calendar[0] ? url : `${url}&where[dateFrom]=${store.state.press.calendar[0]}&where[dateTo]=${store.state.press.calendar[1]}`;

    // Теги
    url = !store.state.press.filterCode ? url : `${url}&where[section]=${store.state.press.filterCode}`;

    // Добавляем номер страницы
    url = `${url}&page[number]=${store.state.press.pageNumber}`;

    return url;
}